export default __webpack_public_path__ + "images/WN.97aeffc.png";